import type { Ref } from 'react';

export function assignRef<T>(ref: Ref<T> | undefined, node: T | null) {
   if (typeof ref === 'function') ref(node);
   else if (ref != null) ref.current = node;
}
